import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import { Close as CloseIcon, DeleteOutlineOutlined as DeleteIcon } from '@mui/icons-material';

const DeleteConfirmDialog = ({ open, onClose, onConfirm, title, message }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      slotProps={{
        paper: {
          sx: { borderRadius: '16px', width: '100%', maxWidth: '400px' }
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Confirm Delete</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', py: 3 }}>
        <Box sx={{ mb: 2 }}>
          <DeleteIcon sx={{ fontSize: 60, color: '#d32f2f', opacity: 0.8 }} />
        </Box>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>{title || 'Are you sure?'}</Typography>
        <Typography variant="body2" color="text.secondary">
          {message || 'This action cannot be undone. This item will be permanently removed.'}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button 
          fullWidth 
          onClick={onClose}
          sx={{ 
            color: '#666', 
            textTransform: 'none', 
            fontWeight: 600,
            borderRadius: '10px',
            '&:hover': { bgcolor: 'rgba(0,0,0,0.05)' }
          }}
        >
          Cancel
        </Button>
        <Button 
          fullWidth 
          variant="contained" 
          onClick={onConfirm}
          sx={{ 
            bgcolor: '#d32f2f', 
            textTransform: 'none', 
            fontWeight: 600,
            borderRadius: '10px',
            '&:hover': { bgcolor: '#b71c1c' }
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
